const fr = {
  auth: {
    signingIn: "Vérification de l'état de connexion...",
    loading: 'Chargement...',
    signInButton: 'Se connecter',
    inactivityError: "Vous avez été déconnecté pour cause d'inactivité. Veuillez vous reconnecter",
  },
  certificationTest: {
    retakeCertificationTestTitle: 'Repasser une certification',
    retakeCertificationTestDescription:
      'Vous êtes sur le point de repasser une certification, votre ancienne note sera effacée, êtes vous sur ?',
  },
  notifications: {
    error: 'Oops...',
    success: 'Success!',
    requestIsProcessing: 'Votre demande est en cours de traitement',
    user: {
      success: {
        description: "L'utilisateur a été mis à jour avec succès.",
      },
      error: {
        description: "Une erreur est survenue lors de la mise à jour de l'utilisateur.",
      },
    },
  },
}

export default fr
